var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMissionFour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 53,
    viewBox: "0 0 63 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.73555,
    y: 9.14424,
    width: 59.0222,
    height: 41.6441,
    rx: 3.1568,
    stroke: "white",
    strokeWidth: 3.4623
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5422 5.06515C24.5422 3.43418 25.8644 2.11201 27.4953 2.11201H34.8273C36.4582 2.11201 37.7804 3.43418 37.7804 5.06515V8.83295H24.5422V5.06515Z",
    stroke: "white",
    strokeWidth: 3.4623
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.402,
    y: 19.2194,
    width: 29.5314,
    height: 16.2932,
    rx: 1.73115,
    stroke: "white",
    strokeWidth: 3.4623
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissionFour);
export default __webpack_public_path__ + "static/media/iconMissionFour.6c938e6d49169bfab963e0bc6fdac401.svg";
export { ForwardRef as ReactComponent };